import { Link, List, StickyNote, Image, FileText, History, Bot } from "lucide-react";
import { useMemo } from "react";
import { useShowInternalDebugInfo } from "@/hooks/useShowInternalDebugInfo";
import type { TabOption } from "./DetailsSectionTabs";

const BASE_TAB_OPTIONS: TabOption[] = [
  { id: "Details", value: "Details", icon: <List /> },
  { id: "Notes", value: "Notes", icon: <StickyNote /> },
  { id: "Agent", value: "Agent", icon: <Bot /> },
  { id: "Documents", value: "Documents", icon: <FileText /> },
  { id: "Photos", value: "Photos", icon: <Image /> },
  { id: "Links", value: "Links", icon: <Link /> },
];

const AUDIT_TRAIL_TAB: TabOption = { id: "AuditTrail", value: "Audit Trail", icon: <History /> };

export const useTabOptions = (isAgentEnabled: boolean): TabOption[] => {
  const showInternalDebugInfo = useShowInternalDebugInfo();
  return useMemo(() => {
    const tabs = isAgentEnabled ? BASE_TAB_OPTIONS : BASE_TAB_OPTIONS.filter((t) => t.id !== "Agent");
    return showInternalDebugInfo ? [...tabs, AUDIT_TRAIL_TAB] : tabs;
  }, [showInternalDebugInfo, isAgentEnabled]);
};
